module.exports = __webpack_public_path__ + "img/flow_2.c35e42d6.png";